import { Company } from './Company';
import { ManufacturerEntity } from './ManufacturerAccount';

export interface UserCredentials {
  eMail: string;
  password: string;
}

export interface LoginRequest extends UserCredentials {
  rememberMe: boolean;
  manufacturer?: ManufacturerEntity;
}

export enum Role {
  ADMIN = 'admin',
  MANUFACTURER = 'manufacturer',
  SERVICE = 'service',
}

export enum Theme {
  DARK = 'dark',
  LIGHT = 'light',
}

interface BaseUser {
  title: string;
  eMail: string;
  phone: string;
  image?: string;
}

export interface TicketUser extends BaseUser {
  address?: string;
  lat?: string;
  lon?: string;
}

export interface SyncUser extends BaseUser {
  id?: string;
  enabled: boolean;
  role: Role;
  company?: Company;
  manufacturer?: ManufacturerEntity;
  settings?: UserSettings;
}

export interface CheckUser extends SyncUser {
  supportInfo: SupportInfo;
}

export interface User extends SyncUser {
  apiKey?: string;
  allUsers?: SyncUser[];
}

export interface Address {
  line1: string;
  line2?: string;
  zip: string;
  city: string;
  country: string;
}

export interface Assignee extends BaseUser {
  company?: Company;
}

export interface SupportInfo {
  id?: string;
  phone: string;
  eMail: string;
  website: string;
}

export interface UserSettings {
  theme: Theme;
}
